<div class="card-wrapper">
  <mad-card title="Expandable Card" [readonly]="true" [expandable]="true">
    <mad-readonly-form-field-wrapper [readonly]="true" [value]="firstName">
      <mat-form-field class="form-group">
        <mat-label>First Name</mat-label>
        <input [(ngModel)]="firstName" autocomplete="off" class="form-control" id="firstName2" matInput name="firstName" />
      </mat-form-field>
    </mad-readonly-form-field-wrapper>
    <mad-readonly-form-field-wrapper [readonly]="true" [value]="lastName">
      <mat-form-field class="form-group">
        <mat-label>Last Name</mat-label>
        <input [(ngModel)]="lastName" autocomplete="off" class="form-control" id="lastName2" matInput name="lastName" />
      </mat-form-field>
    </mad-readonly-form-field-wrapper>

    <mat-chip-listbox aria-label="Fish selection">
      <mat-chip-option>One fish</mat-chip-option>
      <mat-chip-option>Two fish</mat-chip-option>
      <mat-chip-option color="accent" selected>Accent fish</mat-chip-option>
      <mat-chip-option color="warn">Warn fish</mat-chip-option>
    </mat-chip-listbox>
  </mad-card>
</div>
